import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    tone?: 'dark' | 'light'
    dot?: boolean
    className?: string
}

export const Eyebrow: FC<EyebrowProps> = ({
    children,
    tone = 'dark',
    dot = true,
    className
}): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.2em]',
                tone === 'dark' ? 'text-stone-dark' : 'text-beige',
                className
            )}
        >
            {dot && (
                <span
                    aria-hidden='true'
                    className={cn('size-1.5 shrink-0 rounded-full', tone === 'dark' ? 'bg-gold-dark' : 'bg-gold')}
                />
            )}

            {children}
        </span>
    )
}
